import { render, staticRenderFns } from "./CategoryDynamic.vue?vue&type=template&id=70b087e2"
import script from "./CategoryDynamic.vue?vue&type=script&lang=js"
export * from "./CategoryDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports